/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// (function(){
//   var newHTML = document.body.innerHTML;
//   newHTML = newHTML.replace(/S(MOKELETTES?|mokelettes?)\b/g, '$&' + '*');
//   document.body.innerHTML = newHTML;
// })();

function replace(){
	var xpathResult = document.evaluate(
		"//*/text()", 
		document, 
		null, 
		XPathResult.ORDERED_NODE_ITERATOR_TYPE, 
		null
	);
	var results = [];
	// We store the result in an array because if the DOM mutates
	// during iteration, the iteration becomes invalid.
	while(res = xpathResult.iterateNext()) {
		results.push(res);
	}
	results.forEach(function(res){
		res.textContent = res.textContent.replace(/S(MOKELETTES?|mokelettes?)/g,'$&' + '*');
	})
}

setTimeout(replace, 1000);